import { render, staticRenderFns } from "./summary_informant.vue?vue&type=template&id=31b1d8d4"
import script from "./summary_informant.vue?vue&type=script&lang=js"
export * from "./summary_informant.vue?vue&type=script&lang=js"
import style0 from "./summary_informant.vue?vue&type=style&index=0&id=31b1d8d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports